import Cookie from './cookie'

const TokenKey = 'vue_admin_template_token'
const StudentSessionKey = 'yes_audio_student_session'

export function getToken() {
  return Cookie.get(TokenKey)
}

export function setToken(token) {
  return Cookie.set(TokenKey, token)
}

export function removeToken() {
  return Cookie.remove(TokenKey)
}

export function getStudentSession() {
  const raw = localStorage.getItem(StudentSessionKey)
  if (!raw) return null

  try {
    const session = JSON.parse(raw)
    if (session.expiresAt && Date.now() >= session.expiresAt) {
      removeStudentSession()
      return null
    }
    return session
  } catch (error) {
    removeStudentSession()
    return null
  }
}

export function setStudentSession(user) {
  const expiresIn = Number(user.expiresIn || 86400)
  const payload = {
    ...user,
    userId: user.studentId,
    openid: user.studentId,
    expiresAt: Date.now() + expiresIn * 1000
  }
  localStorage.setItem(StudentSessionKey, JSON.stringify(payload))
  if (payload.token) {
    setToken(payload.token)
  }
  return payload
}

export function removeStudentSession() {
  localStorage.removeItem(StudentSessionKey)
  removeToken()
}

export function ensureStudentSession(activityId) {
  const session = getStudentSession()
  if (!session || !session.token) {
    return null
  }
  if (activityId && String(session.activityId) !== String(activityId)) {
    return null
  }
  return session
}



// WEBPACK FOOTER //
// ./src/utils/auth.js